import { render, staticRenderFns } from "./AssemblerLists.vue?vue&type=template&id=3d175978&"
import script from "./AssemblerLists.vue?vue&type=script&lang=ts&"
export * from "./AssemblerLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports